import routes from "../routes/URL";
var fileDownload = require("js-file-download");

// export const root_url = "http://127.0.0.1:8000";
// export const root_url = "https://dev.etableapp.in";
  export  const root_url = "https://etableapp.in";



// const root_url = process.env.REACT_APP_ROOT_URL;
// const root_url = "http://192.168.0.101:8000";  
// const root_url = "https://bus.pressbuddy.in";
// export const root_url = "http://127.0.0.1:8000";
// const root_url = "http://192.168.0.101:8000";

export const base_url = root_url + "/api/hotelowner";

const auth_base_url = root_url + "/api";
export const URL_PATH = {
  rootApi: root_url + "/api",
  base_url: base_url,
  ping: base_url + "/ping",
  latLangToAddress: (lat, lang) =>
    `${root_url}/api/service/latLangToAddress?latitude=${lat}&longitude=${lang}`,
  getStrings: root_url + "/api/service/strings",
  login: auth_base_url + "/auth/v3/login",
  register: auth_base_url + "/auth/v3/register",
  verify_otp: auth_base_url + "/auth/v3/verifyOTP",
  resendOtp: auth_base_url + "/auth/v3/resendOTP",
  profileData: auth_base_url + "/auth/v3/get-details",
  deleteAccount: auth_base_url + "/auth/v2/delete-account",



  //............... COnfig ..............................
  GET_PREFERENCES: base_url + "/hotel/config/get",
  GET_TIMEZONES: (search = "") => 
    base_url + `/hotel/config/timezones${search ? `?search=${search}` : ""}`,

  saveConfig: base_url + "/hotel/config/set",

  getRestroOutletCategory: auth_base_url + "/service/outletCategories",

  getPaymentModes: auth_base_url + "/service/paymentModes",


  //nutriation
 

  //...................... Dinein .....................................................
  floorList: (hotel_id) => base_url + "/hotel-floors/list/" + hotel_id,
  floorTableGrid: (hotel_id) => base_url + "/hotel-floors/" + hotel_id,
  getTableActiveOrders: (table_id) =>
    base_url + `/order/table-active-orders/${table_id}`,
  getKotItems: (kot_id) => base_url + `/order/kot-items/${kot_id}`,
  waiterVisited: `${base_url}/order/waiter-visited`,
  paymentReceivedForOrder: base_url + "/order/updatePayment",
    updatepaymentStatus: base_url + "/order/updatePaymentStatus",
  sendInvoice: (id) => base_url + `/order/sendInvoice/${id}`,

  saveReceiptFooter:base_url + `/order/sendFooter`,
getReceiptFooter:  base_url + `/order/getReceiptFooter`,

  checkoutCustomOrder: (order_id) =>
    base_url + "/order/getCheckoutDetails/" + (order_id != 0 ? order_id : ""),

  finishOrder: (status, order_id) =>
    base_url + "/order/finishOrder?status=" + status + "&order_id=" + order_id,
  //dashboard
  getDashboardData: base_url + `/analytics`,
  getDashboardGraphs: (period, from, to) =>
    base_url + `/analytics/graphs?group_by=${period}&from=${from}&to=${to}`,

  mostOrderDish: base_url + `/analytics/most-ordered-dish`,

  // dashboard v2
  getDashboardDataV2: base_url + `/analytics/dashboardv2`,
  getDashboardGraphsV2: base_url + `/analytics/graphsv2`,

  updateNutritionInfo: (id) => base_url + `/hotel-menu/updateNutrition/${id}`,
  getMenuNutrition: (id) => base_url + `/hotel-menu/getNutrition/${id}`,



markKOTAsPrinted:base_url + `/kot/mark-printed`,



 createCoupon: base_url + "/hotel/hotel-coupon/create",
 updateCouponStatus: base_url + "/hotel/hotel-coupon/change_status",

  

// exportOrderHistoryCSV : (hotelId) => `${base_url}/order/exportOrderHistoryExcel/${hotelId}`,
exportOrderHistoryCSV : (hotelId) => `${base_url}/order/exportOrderHistoryXlsx/${hotelId}`,

exportOrderHistoryPDF :(hotelId) => `${base_url}/order/exportOrderHistoryPdf/${hotelId}`,

  //hotels
  listHotel: base_url + "/hotel/hotels-of-user",
  addHotel: base_url + "/hotel/create",
  deleteHotel: (id) => base_url + `/hotel/delete/${id}`,
  hotelProfile: (id) => base_url + `/hotel/${id}`,
  updateHotel: (id) => base_url + `/hotel/update/${id}`,
  printQrCode: base_url + `/hotel/printQr`,
  printQr: base_url + `/hotel/showQr`,

bankDetailsHotel: (id) => base_url + `/hotel/update-bank-gst/${id}`,
get_active_gateways: base_url + `/gateways/getActiveGateways`,
add_gateways_credentials: base_url + `/gateways`,
update_gateways_credentials: (id) => base_url + `/gateways/${id}`,

get_gateways_credentials: base_url + `/gateways`,





  listAllUsers:(hotel_id) => base_url+`/hotel/customers/${hotel_id}`,
  getCustomerDetail
  :(userId) => base_url+`/user/detail/${userId}`,


  addGuestCustomer: base_url+`/user/create`,


  printTableQr: base_url + `/hotel/printTableQr`,
  printHotelQr: base_url + `/hotel/printHotelQr`,

  //Floors
  listFloor: (id) => base_url + "/hotel-floors/v2/" + id,
  createFloor: base_url + "/hotel-floors/create",
  deleteFloor: (id) => base_url + `/hotel-floors/delete/${id}`,
  updateFloor: (id) => `${base_url}/hotel-floors/update/${id}`,
  // updateFloorStatus: base_url + `/hotel-floors/update-status`,
  fetchFloorDetails: (id) => base_url + `/hotel-floors/details/${id}`,
  deleteBulkFloor:(id) => base_url + `/hotel-floors/delete-bulk/${id}`,

  //..................  Halls ...........................
 hallList: base_url + "/hotel-hall/by-hotel",
  createHall: base_url + "/hotel-hall/add",
  deleteHall: (id) => base_url + `/hotel-hall/delete/${id}`,
  updateHall: (id) => `${base_url}/hotel-hall/${id}`,
  fetchHallDetails: (id) => base_url + `/hotel-hall/${id}`,


  //................ Tables ...............................
  listTable: (id) => base_url + "/hotel-table/" + id,
  createTable: base_url + "/hotel-table/create",
  deleteTable: (id) => base_url + `/hotel-table/delete/${id}`,
  updateTable: (id) => `${base_url}/hotel-table/update/${id}`,
  fetchTableDetails: (id) => base_url + `/hotel-table/details/${id}`,
updateTableStatus: (id) => `${base_url}/hotel-table/change_table_status/${id}`,
 
  //Category
  listCategory: (id) => base_url + "/hotel-category/" + id,
  listCategoryForDropdown: (id) => base_url + "/hotel-category/dropdown/" + id,
  createCategory: base_url + "/hotel-category/create",
  deleteCategory: (id) => base_url + `/hotel-category/delete/${id}`,
  updateCategory: (id) => `${base_url}/hotel-category/update/${id}`,
  updateCategoryStatus: base_url + `/hotel-category/update-status`,
  catagoryDetails: (category_id) =>
    base_url + `/hotel-category/details/${category_id}`,

  //Menu
  listMenu: (id) => base_url + "/hotel-menu/" + id,
  createMenu: base_url + "/hotel-menu/create",
  deleteMenu: (id) => base_url + `/hotel-menu/delete/${id}`,
  updateMenuStatus: base_url + `/hotel-menu/update-status`,
  menuByCategoryId: (category_id) =>
    `${base_url}/hotel-menu/by-category-id/${category_id}`,
  menuDetails: (menu_id) => base_url + `/hotel-menu/details/${menu_id}`,
  updateMenu: (id) => `${base_url}/hotel-menu/update/${id}`,
  deleteBulkMenu: (id) => base_url + `/hotel-menu/delete-bulk/${id}`,
  addArModel: (id) => base_url + `/hotel-menu/add_AR_Model/${id}`,





  //menu attributes,variation, addons
  removeVariation: base_url+ "/hotel-menu/variation/delete",
  updateVariationPrice: base_url+ "/hotel-menu/variation/update",
  getVariations: base_url+ "/hotel-menu/variation/singleItemAllVariations/get",

  addaddon: base_url+ "/hotel-menu/addonFields",
  updateaddon: base_url+ "/hotel-menu/addonFields/",
  deleteBulkMenu: (id) => base_url + `/hotel-menu/delete-bulk/${id}`,
  getAddons: base_url + `/hotel-menu/addonFields/get`,
  deleteAddon: base_url + `/hotel-menu/addonFields/delete/`,


getAttributes:(id) => base_url + `/hotel-menu/attribute/detailse/${id}`,
saveAttributes: base_url + "/hotel-menu/attribute/storeSingle",
deleteAttribute : base_url +"/hotel-menu/attribute/delete",
addSingleAttribute:base_url +"/hotel-menu/attribute/storeSingle",
  // getSpacesWisePrice: base_url+ "/hotel-menu/areaPrices/generate",
  saveSpacesWisePrice: base_url+ "/hotel-menu/areaPrices/update",

  getSpacesWisePrices: base_url+ "/hotel-menu/areaPrices/generate",

  getSpacesWisePrice: base_url+ "/hotel-menu/areaPrices/singleItemTotalAreaPrice/get",

  //orders



report: (hotelId = "", type = "", from_date = "", to_date = "", exportType = "", searchBy = "", searchContent = "") =>
    base_url + "/analytics/listing-reports?hotel_id=" + hotelId + "&type=" + type + "&from_date=" + from_date + "&to_date=" + to_date + "&exportType=" + exportType + `&${searchBy}=${searchContent}`,
    
  liveOrders: (hotel_id, order_type, order_status) =>
    base_url +
    "/order/active-orders?hotel_id=" +  
    hotel_id +
    "&order_type=" +
    order_type +
    "&order_status=" +
    order_status,
  updateOrderStatus: base_url + "/order/update-order-status",
  orderHistory: (page = 1, start_date = "", end_date = "", filter = "all",payment_method = "all") =>
    base_url +
    "/order/order-history?start_date=" +
    start_date +
    "&end_date=" +
    end_date +
    "&page=" +
    page +
    "&filter=" +
    filter+
    "&payment_method="+
    payment_method,
  OrderHistoryDetail: (id) => base_url + `/order/getOrderDetails/${id}`,
  heckoutCustomOrder: (order_id) =>
    base_url + "/order/getCheckoutDetails/" + (order_id != 0 ? order_id : ""),
  applyCustomDiscount: (order_id, discount) =>
    base_url +
    `/order/applyCustomDiscount?order_id=${order_id}&discount=${discount}`,
  applyWaiter: 
      `${root_url}/api/user/order/add_waiter_tip`,
  //...................  Finish Order .....................................................
  finishOrder: (status, order_id, payment_method) =>
    base_url + "/order/finishOrder?status=" + status + "&order_id=" + order_id + "&payment_method=" + payment_method,

  deleteOrder: (id) => base_url + `/order/deleteOrder/${id}`,
  deleteBulkOrderHistory: (id) => base_url + `/order/deleteOrder-bulk/${id}`,

  cancelOrder: (order_id) => base_url + `/order/cancelOrder/${order_id}`,

  updateOrder: base_url + "/order/updateOrder",

  //Bookings
  // activeBookings: (hotel_id, booking_type) =>
  //   base_url +
  //   "/booking/active-bookings?hotel_id=" +
  //   hotel_id +
  //   "&booking_type=" +
  //   booking_type,
  activeBookings: (hotel_id, booking_type, status) =>
    base_url +
    "/booking/active-bookings?hotel_id=" +
    hotel_id +
    "&booking_type=" +
    booking_type +
    "&status=" +
    status,
  updateBookingStatus: base_url + "/booking/update-booking-status",
  bookingHistory: base_url + "/booking/booking-history",
  // bookingDetails: base_url + `/booking/booking-details`,
  bookingDetails: (booking_id) =>
    base_url + `/booking/booking-details/${booking_id}`,
  //Dashboard
  floorList: (hotel_id) => base_url + "/hotel-floors/list/" + hotel_id,
  floorTableGrid: (hotel_id) => base_url + "/hotel-floors/" + hotel_id,
  getTableActiveOrders: (table_id) =>
    base_url + `/order/table-active-orders/${table_id}`,
   getCurrentOrderStatusOrders: (order_id) => 
    base_url + `/order/getCurrentOrderStatusDetails/${order_id}`,
  
  getKotItems: (kot_id) => base_url + `/order/kot-items/${kot_id}`,
  //Users
  listUsers: (hotel_id) => base_url + "/user/list/" + hotel_id,

  updateUser: (id) => base_url + `/user/updatestaff/${id}`,

  getUserData: (user_id) => base_url + `/user/detail/${user_id}`,
  getAllAvailablePermissions: base_url + "/user/list-available-permissions",
  updateUserAccessControl: base_url + "/user/update-access-control",
  createUser: base_url + "/user/create_staff",
  deleteUser: (user_id) => base_url + `/user/delete/${user_id}`,

  //subscription
  subscriptionPlans: base_url + "/subscription/plans",
  subscribeToPlan: base_url + "/subscription/subscribe",
  getSubscriptionCost: base_url + "/subscription/change-plan-get-cost",

  renewPlan: base_url + "/subscription/renew",
  paymentDone: base_url + "/subscription/process_notify",
  upgradePlan: base_url + "/subscription/change-plan",
  //Digital Token
  ListDigitalTokenForHotel: (hotel_id) =>
    base_url + `/digital-token/list?hotel_id=${hotel_id}`,
  //KOT
  listKOT: (hotel_id) => base_url + `/kot/list/${hotel_id}`,
  listKOTV2: (hotel_id) => base_url + `/kot/listv2/${hotel_id}`,

  serveall: (hotel_id) => base_url + `/kot/update_all/${hotel_id}`,



  updateKOTStatus: base_url + `/kot/update-status`,
  //Inventory
  getSuppliers: (hotel_id) => base_url + `/inventory/supplier/list`,
  getOutlets: (id) => base_url + `/hotel/getOutlets/${id}`,

  listInventory: base_url + `/inventory/invoice/list`,
  createInventoryInvoice: base_url + `/inventory/invoice/create`,
  updateInventoryInvoice: (id) => `${base_url}/inventory/invoice/update/${id}`,
  getInventoryInvoiceDetails: (id) =>
    `${base_url}/inventory/invoice/detail/${id}`,
  deleteInventoryInvoice: (id) => `${base_url}/inventory/invoice/delete/${id}`,
  bulkDeleteInventory:(id) => `${base_url}/inventory/invoice/delete-bulk/${id}`,
    updateSupplier: (id) => `${base_url}/inventory/supplier/update/${id}`,
      fetchSupplierDetails: (id) => base_url + `/inventory/supplier/detail/${id}`,




    listAllCoupons: (hotel_id) => base_url + `/hotel/hotel-coupon/coupon?hotel_id=${hotel_id}`,
    addCoupon: base_url + `/hotel/hotel-coupon/create`,
    deleteCoupon: base_url + `/hotel/hotel-coupon/delete`,
    updateCoupon: base_url + `/hotel/hotel-coupon/update`,
    getCoupon: (coupon_id) => base_url + `/hotel/hotel-coupon/couponById?coupon_id=${coupon_id}`,





  //Custom Billing
  getHotelCatagoriesWithMenu: (id) =>
    `${base_url}/hotel-category/with-menu/${id}`,
  hotelMenuSearch: (hotel_id, search) =>
    `${base_url}/hotel-menu/search/${hotel_id}/${search}`,
  //{{host}}/hotelowner/hotel-table/list-all-for-hotel/f0b7e6e9-7e3c-480e-8180-699f4ee8269b
  listAllTablesForHotel: (hotel_id) =>
    `${base_url}/hotel-table/list-all-for-hotel/${hotel_id}`,
  addFoodToTable: base_url + `/order/addFoodToTable`,
  createCustomBilling: base_url + `/custom-billing/create`,
  listCustomBilling: `${base_url}/custom-billing/list`,
  //-------------------------------  Support Ticket  ------------------------------------------------------------------------------
  //Submit Ticket
  submitTicket: `${base_url}/support-ticket/createTicket`,
  //Add comment to Ticket
  addCommentToTicket: `${base_url}/support-ticket/replyTicket`,
  //Get All Active Tickets
  getAllActiveTickets: `${base_url}/support-ticket/getActiveTickets`,
  //Get Tickets History
  getTicketsHistory: `${base_url}/support-ticket/getTicketHistory`,
  //Get Ticket Detail
  getTicketDetails: (ticket_id) =>
    `${base_url}/support-ticket/getTicketDetails/${ticket_id}`,
  //employees
  listEmployees: base_url + `/employee/list`,
  createEmployee: base_url + `/employee/create`,
  updateEmployee: `${base_url}/employee/update`,
  deleteEmployee: (id) => `${base_url}/employee/delete`,
  deleteBulkEmployees: (hotelId) =>
    base_url + `/employee/delete-bulk/${hotelId}`,
  employeeDetails: (employee_id) =>
    base_url + `/employee/detail?employee_id=${employee_id}`,

  // ........................  BAnners   ................................................
  listBanners: base_url + `/banner`,
  addNewBanner: base_url + `/banner/create`,
  deleteBanner: (id) => base_url + `/banner/delete/${id}`,
  changeStatusBanner: (id) => base_url + `/banner/update/` + id,

  // ........................  payment request   ................................................
  getPaymentRequests: base_url + `/order/getPaymentRequests`,
  getPaymentRequestsofSplit:`${base_url}/order/inHouseSplitPayments`,
  confirmSplitPaymentReq:`${base_url}/order/splitCashPaymentsConfirm`,

  // ........................  badge   ................................................
  badges: base_url + "/hotel/badges",

  // ........................  badge   ................................................
  availabelTablesForDigitalToken: (hotel_id) =>
    base_url + `/digital-token/available-tables/${hotel_id}`,
  orderDetails: (order_id) =>
    base_url + `/digital-token/order-detail/${order_id}`,

  assignTable: base_url + `/digital-token/assign-table`,
  assignTableForBooking: base_url + "/booking/assign-table-for-booking",

    // ........................  reviews   ................................................

reviews: (page = 1, start_date = "", end_date = "") =>
  base_url +
  "/analytics/review?start_date=" +
  start_date +
  "&end_date=" +
  end_date +
  "&page=" +
  page,
};


const isDev = true;
export const log = (str) => {
  if (!isDev) return;
  console.log("====================================");
  console.log(str);
  console.log("====================================");
};

export default async (
  obj,
  method,
  url,
  data = {},
  header = {},
  showLoader = true
) => {
  // const response = await window.axios.get(url);
  // loading.start(obj);
  try {
    if (showLoader) obj.props.setLoading(true);
  } catch (e) {
    // alert(e);
    console.log(e);
  }
  log("sending request ...." + url);
  try {
    //add extra headers if passed
    const response = await window.axios(
      method == "get"
        ? { 
            method,
            url,
            headers: header,     // <-- add this line
            params: data,
            responseType: data.export ? "blob" : "application/json", // important
          }
        : {
            method,
            url,
            data,
            headers: header,
            responseType: data.export ? "blob" : "application/json", // important
          }
    );
    // loading.stop(obj);
    try {
      obj.props.setLoading(false);
    } catch (error) {}
    // log("response...." + url + " " + JSON.stringify(response));

    if (data.export) {
      fileDownload(
        response.data,
        data.exportFile ?? "data_" + Date.now() + ".csv"
      );
      // const href = URL.createObjectURL(response.data);
      // const elem = document.createElement("a");
      // elem.setAttribute("href", href);
      // elem.setAttribute("download", "export.csv");
      // elem.style.display = "none";
      // document.body.appendChild(elem);
      // elem.click();
      // document.body.removeChild(elem);
      // URL.revokeObjectURL(href);
      return null;
    }
    return response.data;
  } catch (error) {
    console.log(error.response.status);

    try {
      obj.props.setLoading(false);
      if (error.response.status == 401) {
        // localStorage.getItem("token");
        localStorage.removeItem("token");
        obj.props.setAuth(false);
        // obj.props.history.push("/login");
        // this.context.history.push("/login");
        window.push(routes.auth.login);
        // alert("redirect to login");
      }
      
    } catch (e) {
      console.log(e);
      // window.Alert(e);
    }
    return [];
  }
};
